export default __webpack_public_path__ + "static/media/UHD_PRO_Mini.dc84efe6.png";